import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import Autocomplete from '@mui/material/Autocomplete'
import { Link } from 'react-router-dom'
import { Alert, AlertTitle, Grid, TextField , Typography} from '@mui/material'
import { useHistory } from 'react-router-dom'
import popUpMessage from '../../config/popUpMsg.json'
import payloadCountry from '../../config/vendorPicklistApiPayload.json'
import api from '../../service/api';
import ProgressBar from '../progress/progressBar'
import useLocalStorage from '../../hooks/useLocalStorage'
import { sortTranslated } from '../shared/util'

function ConfirmationDialogRaw (props) {
  const history = useHistory()
  const [popMsg] = useState(popUpMessage.newHCP)
  const { onOk, option, open, entityType } = props
  const [value, setValue] = useState(
    props.selectedCountry
      ? {
          id: props.selectedCountry,
          name: props.selectedCountry,
          label: props.selectedCountry
        }
      : ''
  )
  const [noCountryError, setNoCountryError] = React.useState(false)
  const [noSpecialtyError, setNoSpecialtyError] = React.useState(false)
  const [countrySelected, setCountryselected] = useState(props.selectedCountry)
  const [allCountry, setAllCountry] = useState('')
  const [primarySpecialty, setPrimarySpecialty] = useState(props.primarySpecialty ? props.primarySpecialty : [])
  const [otherSpecialty, setOtherSpecialty] = useState(props.otherSpecialty ? props.otherSpecialty :[])
  const [selectedSpecialityValue, setSelectedSpecialityValue] = useState(
    props.SelectedSpecialtyValue ? props.SelectedSpecialtyValue : ''
  )
  const [loading, setLoading] = useState(false)
  let dropdown_vendor = []
  let new_hcp_all_sources_country = []
  let findUniqueValue = []
  const [langLocaleChange] = useLocalStorage('wglang_api')
  useEffect(() => {
    if(countrySelected){
      handleChange(undefined, value, 'country')
    }
  }, [langLocaleChange])

  useEffect(() => {
    //finding out all the countries value for vendor
    option.map((filter, key) => {
      if (filter.split('#')[1] == 'IQVIA' || filter.split('#')[0] == 'United States' || filter.split('#')[1] == 'OPEN-DATA') {
        dropdown_vendor.push({
          id: filter,
          name: filter,
          label: filter.split('#')[0]
        })
      }
      if (filter.split('#')[1] == 'IQVIA' || !filter.includes('#') || filter.split('#')[1] == 'VNDR-VOD' || filter.split('#')[0] == 'United States' || filter.split('#')[1] == 'OPEN-DATA') {
        findUniqueValue.push(filter.split('#')[0])
      }
    })
    findUniqueValue = findUniqueValue
      .filter(
        (value, index, self) => index === self.findIndex(t => t === value)
      )
      .sort((a, b) => {
        return a > b ? 1 : -1
      })
    ////finding out all the countries value for EPH
    findUniqueValue.map((filter, key) => {
      new_hcp_all_sources_country.push({
        id: filter.split('#')[0],
        name: filter.split('#')[0],
        label: filter.split('#')[0]
      })
    })
    setAllCountry(new_hcp_all_sources_country)
    //logic for editing country, specialty values in new hcp component
    if (
      (primarySpecialty.length == 0 || otherSpecialty.length == 0) &&
      selectedSpecialityValue != ''
    ) {
      // let getPaylodCountry = payloadCountry.countries.find(
      //   res => res?.country_Name == props.selectedCountry
      // )
      // let countrySpecificSpecialty = [
      //   ...new Set(
      //     allSpecialty[
      //       getPaylodCountry
      //         ? getPaylodCountry.key.payloadKey
      //         : props.selectedCountry
      //     ]
      //   )
      // ]
      // Apply the Proper Case conversion and sorting
      // setPrimarySpecialty(
      //   primarySpecialty.sort((a, b) => a.localeCompare(b))
      // )
      // setOtherSpecialty(
      //   otherSpecialty.sort((a, b) => a.localeCompare(b))
      // )
    }
  }, [])

  // routing the pop up data to appropriate component also checking the values
  const handleOk = () => {
    let selectedSpecialty = []
    selectedSpecialty.push(
      selectedSpecialityValue?.PrimarySpecialty?.[0]?.value
    )
    if (
      selectedSpecialityValue !== null &&
      selectedSpecialityValue !== undefined &&
      selectedSpecialityValue.PrimarySpecialty &&
      !noCountryError &&
      !noSpecialtyError
    ) {
      onOk(
        countrySelected ? countrySelected : props.selectedCountry,
        selectedSpecialityValue,
        selectedSpecialty.concat(
          selectedSpecialityValue?.OtherSpecialty?.[0]?.value || []
        ), primarySpecialty, otherSpecialty
      )
    } else {
      if (value == null || value === '') {
        setNoCountryError(
          !(value !== null && value !== undefined && value.length > 0)
        )
      } else if (
        selectedSpecialityValue == null ||
        !selectedSpecialityValue.PrimarySpecialty
      ) {
        setNoSpecialtyError(true)
      }
    }
  }

  function toProperCase (string) {
    return string
      .toLowerCase() // Convert the entire string to lowercase first
      .split(/(\W+)/) // Split by non-word characters
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter
      .join('') // Rejoin the string parts
  }

  const handleChange = (event, value, id) => {
    if (value != null && value != '') {
      if (id == 'country') {
        var getPaylodCountry = payloadCountry.countries.find(
          res => res?.country_Name == value.label
        )
        setLoading(true)
        api.getPickList((getPaylodCountry ? getPaylodCountry.key.payloadKey : value.label), undefined, undefined, undefined, undefined, langLocaleChange).then((res) => {        
          let response = res.data[0]

          // use "spclty_vn" when country is United States and entity type is HCP (#IQVIA_US IQVIA HCO Project)
          if (value.label == 'United States' && entityType == "HCP") {
            setPrimarySpecialty(response.HCP.spclty_vn)
          } else {
            setPrimarySpecialty(response.HCP.spclty)
          }
          setLoading(false)
          }).catch((error) => {
              // let errorDetail = error;
              // let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
              setLoading(false)
          })

        // let countrySpecificSpecialty = [
        //   ...new Set(
        //     allSpecialty[
        //       getPaylodCountry ? getPaylodCountry.key.payloadKey : value.label
        //     ]
        //   )
        // ]

        // setPrimarySpecialty(countrySpecificSpecialty)
        setCountryselected(value.id)
        setValue(value)
        setSelectedSpecialityValue('')
        setNoCountryError(false)
      } else if (id == 'PrimarySpecialty') {
        setOtherSpecialty(primarySpecialty.filter((res)=> res != value))
        setSelectedSpecialityValue({
          ...selectedSpecialityValue,
          [id]: [{ value: value }]
        })
        if(selectedSpecialityValue.OtherSpecialty && selectedSpecialityValue.OtherSpecialty[0]['value'].length > 0){
          let matchedSpecialtyIndex = selectedSpecialityValue.OtherSpecialty[0]['value'].findIndex((res)=> res == value )
          if(matchedSpecialtyIndex != -1){
            selectedSpecialityValue.OtherSpecialty[0]['value'].splice(matchedSpecialtyIndex, 1)
          }
        }
        setNoSpecialtyError(false)
      } else {
        setSelectedSpecialityValue({
          ...selectedSpecialityValue,
          [id]: [{ value: value }]
        })
      }
    } else {
      if (id == 'country' && (value == null || value == '')) {
        setSelectedSpecialityValue('')
        setNoCountryError(
          !(value !== null && value !== undefined && value.length > 0)
        )
        setValue('')
      } else if (id == 'PrimarySpecialty' && (value == null || value == '')) {
        setSelectedSpecialityValue('')
        setNoSpecialtyError(
          !(
            selectedSpecialityValue !== null &&
            selectedSpecialityValue !== undefined &&
            selectedSpecialityValue.length > 0
          )
        )
      } else {
        setSelectedSpecialityValue({
          ...selectedSpecialityValue,
          [id]: [{ value: value }]
        })
      }
    }
  }

  const handleCancel = () => {
    props.cancel()
  }

  const handlehcpCancel = () => {
    props.showAllData ? props.onCancel() : history.push('/')
    setValue(props.selectedCountry
      ? {
          id: props.selectedCountry,
          name: props.selectedCountry,
          label: props.selectedCountry
        }
      : '')
    setSelectedSpecialityValue(props.SelectedSpecialtyValue ? props.SelectedSpecialtyValue : '')
  }

  return (
    <Dialog
      maxWidth={'md'}
      aria-labelledby='confirmation-dialog-title-1'
      open={open}
      keepMounted
      fullWidth
    >
      {option && option?.length !== 0 && (
        <>
          <DialogTitle id='confirmation-dialog-title'>
          <Typography sx={{color:"#DC3545", fontSize:"20px"}}>{`Add New ${props.entity}`}</Typography>
              <Typography sx={{color:"#707070", fontSize:"14px"}}> {props.manageAccess
              ? popMsg[0].countryPopUp.heading1
              : popMsg[0].countryPopUp.heading}</Typography>
          </DialogTitle>
          <DialogContent dividers id='newhcp-text'>
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              flex-wrap='wrap'
              alignItems='center'
            >
              <Grid item md={5.5} xs={12}>
                <Autocomplete
                  disableClearable
                  value={value}
                  key={!props.manageAccess ? 'Country' : 'Group'}
                  options={sortTranslated(allCountry)}
                  onChange={(event, value) => {
                    handleChange(event, value, 'country')
                  }}
                  getOptionLabel={option => (option.label ? option.label : '')}
                  isOptionEqualToValue={(optionn, value) =>
                    optionn.id === value.id
                  }
                  id={!props.manageAccess ? 'Country' : 'Group'}
                  name={!props.manageAccess ? 'Country' : 'Group'}
                  renderInput={params => (
                    <TextField
                      {...params}
                      error={noCountryError}
                      label={!props.manageAccess ? 'Country' : 'Group'}
                      variant='standard'
                      helperText={
                        noCountryError ? 'Please Select One Option' : ' '
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <ProgressBar color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    />
                  )}
                />
              </Grid>
           
              {(primarySpecialty?.length > 0)  && !loading && (
                <Grid item md={5.5} xs={12}>
                  <Autocomplete
                    fullWidth
                    value={
                      selectedSpecialityValue.PrimarySpecialty
                        ? selectedSpecialityValue.PrimarySpecialty[0].value
                        : ''
                    }
                    options={sortTranslated(primarySpecialty)}
                    onChange={(event, value) => {
                      handleChange(event, value, 'PrimarySpecialty')
                    }}
                    getOptionLabel={option =>
                      toProperCase(option.split(' | ')[0])
                    }
                    isOptionEqualToValue={(option, value) => option === value}
                    id='primary-Specialty'
                    name='primary-Specialty'
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option}>
                          {toProperCase(option.split(' | ')[0])}
                        </li>
                      )
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        error={noSpecialtyError}
                        label={'Primary Specialty'}
                        variant='standard'
                        helperText={
                          noSpecialtyError ? 'Please Select One Option' : ' '
                        }
                      />
                    )}
                  />
                </Grid>
              )}

              {selectedSpecialityValue.PrimarySpecialty && (
                <Grid item md={12} xs={12}>
                  <Autocomplete
                    multiple
                    value={
                      selectedSpecialityValue.OtherSpecialty
                        ? selectedSpecialityValue.OtherSpecialty[0].value
                        : []
                    }
                    key='other-Specialty'
                    options={sortTranslated(otherSpecialty)}
                    getOptionLabel={option =>
                      toProperCase(option.split(' | ')[0])
                    }
                    onChange={(event, value) => {
                      handleChange(event, value, 'OtherSpecialty')
                    }}
                    isOptionEqualToValue={(option, value) => option == value}
                    id='other-specialty'
                    name='other-specialty'
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option}>
                          {toProperCase(option.split(' | ')[0])}
                        </li>
                      )
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label={'Other Specialty'}
                        variant='standard'
                      />
                    )}
                  />
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions className='_wg-dynamic-text'>
            {props.manageAccess === undefined && (
              // <Link to='/' className='text-decoration-none custombutton' id="cancel" color="error" variant="outlined">
              //     Cancel
              // </Link>
              <Button
                onClick={handlehcpCancel}
                color='error'
                variant='outlined'
              >
                Cancel
              </Button>
            )}
            {props.manageAccess && (
              <Button onClick={handleCancel} color='error' variant='outlined'>
                Cancel
              </Button>
            )}
            <Button onClick={handleOk} color='error' variant='contained'>
              Confirm
            </Button>
          </DialogActions>
        </>
      )}

      {option && option?.length == 0 && (
        <Alert severity='error' className='container' id='alert-text'>
          <AlertTitle>You Dont have Acces to Add New HCP.</AlertTitle>
          <Link to='/'>
            <strong className='link pointer text-primary'>back!</strong>
          </Link>
        </Alert>
      )}
    </Dialog>
  )
}

ConfirmationDialogRaw.propTypes = {
  onOk: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  option: PropTypes.array.isRequired,
  // data: PropTypes.object.isRequired,
}
export default ConfirmationDialogRaw
